export class ApiInterceptorConstants {
  static N8nHackathonRoute: string = 'https://n8n-hackathon.dev.triparcdev.com/';
}